import { ArrowUpRight, Megaphone } from "lucide-react";
import { FadeUp, Overline } from "@/components/motion";
import { useSite } from "@/context/SiteContext";
import { useLang } from "@/context/LangContext";

export const Announcements = () => {
  const { announcements } = useSite();
  const { pick, t } = useLang();
  const items = announcements.filter((a) => a?.active);
  if (!items.length) return null;
  return (
    <section data-testid="announcements-section" className="mx-auto max-w-[1400px] px-5 py-16 md:px-10">
      <Overline>{t("ann.title")}</Overline>
      <div className="mt-8 grid gap-4 md:grid-cols-2">
        {items.map((a, i) => (
          <FadeUp key={a.id} delay={i * 0.06} className="group relative overflow-hidden rounded-[24px] border border-[#D4AF37]/20 bg-[#131C2E] p-7" data-testid={`announcement-${a.id}`}>
            <Megaphone className="h-5 w-5 text-[#D4AF37]" strokeWidth={1.5} />
            <h3 data-ve-rec={`announcements|${a.id}|title_`} className="font-display mt-5 text-3xl font-semibold text-[#F4EEE2]">{pick(a.title_en, a.title_mh)}</h3>
            {(a.body_en || a.body_mh) && <p data-ve-rec={`announcements|${a.id}|body_`} className="mt-3 whitespace-pre-line text-sm leading-relaxed text-[#C9D0DB]">{pick(a.body_en, a.body_mh)}</p>}
            {a.link && (
              <a href={a.link} target="_blank" rel="noreferrer" data-testid={`announcement-link-${a.id}`} className="mt-5 inline-flex items-center gap-1.5 font-ui text-sm font-semibold text-[#D4AF37] hover:underline">
                {t("ann.more")} <ArrowUpRight className="h-4 w-4" />
              </a>
            )}
          </FadeUp>
        ))}
      </div>
    </section>
  );
};
